import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../../Profile/Accounts_react/AccountsUtils';
import InputDollar from '../../../InputDollar/InputDollarView';
import {
  amountValidator,
  yearValidator,
  descriptionValidator,
} from '../../LargePurchaseWorkflowValidators';

const ItemDescription = ({
  workflowId,
  branch,
  clientId,
  store,
  purchaseAmount,
  onPostSave,
  onPostProcess,
  isNew,
  goal,
  purchaseYear,
  purchaseYearOptions,
  itemDescription,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.Cost`} />

    <h2>What is the expected purchase price?</h2>

    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            className="md"
            placeholder="Amount"
            id="adv-amount"
            value={purchaseAmount}
            onChange={inputTextChanged(clientId, store(workflowId), `${BACKEND_KEY}.Cost`)}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={amountValidator(purchaseAmount)}
      validationId={`${BACKEND_KEY}.Cost`}
      doNotSave={
        yearValidator(purchaseYear, purchaseYearOptions)().length > 0 ||
        descriptionValidator(itemDescription)().length > 0
      }
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      onPostSave={onPostSave(isNew, workflowId, clientId)}
      onPostProcess={onPostProcess(goal)}
    />
  </AdvWorkflowStep>
);

ItemDescription.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  store: PropTypes.func.isRequired,
  purchaseAmount: PropTypes.number.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  goal: PropTypes.shape().isRequired,
  onPostSave: PropTypes.func.isRequired,
  isNew: PropTypes.bool.isRequired,
  itemDescription: PropTypes.string.isRequired,
  purchaseYear: PropTypes.number.isRequired,
  purchaseYearOptions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};

export default ItemDescription;
